import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBannerSlideshow, LazyBigNumbersDisplay, LazyBlokHeader, LazyButtonSection, LazyClientReviewsDisplay, LazyColoredHorizontalRuler, LazyColumnDisplay, LazyCompanyHistory, LazyCompanyTeam, LazyComparisonTable, LazyContentButton, LazyContentHorizontalRuler, LazyCustomPageHeader, LazyFileList, LazyFunnelInfo, LazyFunnelSidebarProviders, LazyGlossary, LazyHeroAbout, LazyHeroContact, LazyHeroLanding, LazyHeroPress, LazyHighlightBox, LazyMediaContentImage, LazyMediaContentSlideshow, LazyMediaContentVideo, LazyMediaReviewsDisplay, LazyMultiContent, LazyNavigationButton, LazyNewsReviews, LazyPage, LazyProviderInfo, LazyProviderSelector, LazyProviderSliderDisplay, LazyRelatedPostsDisplay, LazyServiceMethod, LazySimulatorHeader, LazySimulatorList, LazySlideBanner, LazySpeedTestEmbed, LazySpeedTestInfo, LazyStoryblokBanner, LazySubLandingInfo, LazySubLandingLinksDisplay, LazyTable, LazyTipBox, LazyAuthor, LazyBlogGuides, LazyBlogMain, LazyCategories, LazyPost, LazyRubric, LazySearch, LazyFeaturedGuidesList, LazyFeaturedPostsList, LazyPollWidget, LazyPostPreview, LazyElectricMobilityResults, LazyFaq, LazyFaqQuestion, LazyFaqSection, LazyBarGraph, LazyEuriborGraph, LazyEuriborTable, LazyLineGraph, LazyRoundGraph, LazyHeroTile, LazyHeroTiles, LazyPanelBroadband, LazyPanelCarInsurance, LazyPanelCreditCard, LazyPanelHomeLoan, LazyPanelHomeLoanTransfer, LazyPanelInfo, LazyPanelInvoiceReader, LazyPanelLeadCapture, LazyPanelMultiNavigation, LazyPanelPersonalLoan, LazyReferralForm, LazyProductShowcase, LazyProductShowcaseItemBb, LazyProductShowcaseItemCc, LazySimulatorDeed, LazySimulatorEuribor, LazySimulatorHomeLoan, LazySimulatorImi, LazySimulatorIrs, LazySimulatorIrsTable, LazySimulatorLoan, LazySimulatorWage, LazySimulatorWageTable, LazyLegalText, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["BannerSlideshow", LazyBannerSlideshow],
["BigNumbersDisplay", LazyBigNumbersDisplay],
["BlokHeader", LazyBlokHeader],
["ButtonSection", LazyButtonSection],
["ClientReviewsDisplay", LazyClientReviewsDisplay],
["ColoredHorizontalRuler", LazyColoredHorizontalRuler],
["ColumnDisplay", LazyColumnDisplay],
["CompanyHistory", LazyCompanyHistory],
["CompanyTeam", LazyCompanyTeam],
["ComparisonTable", LazyComparisonTable],
["ContentButton", LazyContentButton],
["ContentHorizontalRuler", LazyContentHorizontalRuler],
["CustomPageHeader", LazyCustomPageHeader],
["FileList", LazyFileList],
["FunnelInfo", LazyFunnelInfo],
["FunnelSidebarProviders", LazyFunnelSidebarProviders],
["Glossary", LazyGlossary],
["HeroAbout", LazyHeroAbout],
["HeroContact", LazyHeroContact],
["HeroLanding", LazyHeroLanding],
["HeroPress", LazyHeroPress],
["HighlightBox", LazyHighlightBox],
["MediaContentImage", LazyMediaContentImage],
["MediaContentSlideshow", LazyMediaContentSlideshow],
["MediaContentVideo", LazyMediaContentVideo],
["MediaReviewsDisplay", LazyMediaReviewsDisplay],
["MultiContent", LazyMultiContent],
["NavigationButton", LazyNavigationButton],
["NewsReviews", LazyNewsReviews],
["Page", LazyPage],
["ProviderInfo", LazyProviderInfo],
["ProviderSelector", LazyProviderSelector],
["ProviderSliderDisplay", LazyProviderSliderDisplay],
["RelatedPostsDisplay", LazyRelatedPostsDisplay],
["ServiceMethod", LazyServiceMethod],
["SimulatorHeader", LazySimulatorHeader],
["SimulatorList", LazySimulatorList],
["SlideBanner", LazySlideBanner],
["SpeedTestEmbed", LazySpeedTestEmbed],
["SpeedTestInfo", LazySpeedTestInfo],
["StoryblokBanner", LazyStoryblokBanner],
["SubLandingInfo", LazySubLandingInfo],
["SubLandingLinksDisplay", LazySubLandingLinksDisplay],
["Table", LazyTable],
["TipBox", LazyTipBox],
["Author", LazyAuthor],
["BlogGuides", LazyBlogGuides],
["BlogMain", LazyBlogMain],
["Categories", LazyCategories],
["Post", LazyPost],
["Rubric", LazyRubric],
["Search", LazySearch],
["FeaturedGuidesList", LazyFeaturedGuidesList],
["FeaturedPostsList", LazyFeaturedPostsList],
["PollWidget", LazyPollWidget],
["PostPreview", LazyPostPreview],
["ElectricMobilityResults", LazyElectricMobilityResults],
["Faq", LazyFaq],
["FaqQuestion", LazyFaqQuestion],
["FaqSection", LazyFaqSection],
["BarGraph", LazyBarGraph],
["EuriborGraph", LazyEuriborGraph],
["EuriborTable", LazyEuriborTable],
["LineGraph", LazyLineGraph],
["RoundGraph", LazyRoundGraph],
["HeroTile", LazyHeroTile],
["HeroTiles", LazyHeroTiles],
["PanelBroadband", LazyPanelBroadband],
["PanelCarInsurance", LazyPanelCarInsurance],
["PanelCreditCard", LazyPanelCreditCard],
["PanelHomeLoan", LazyPanelHomeLoan],
["PanelHomeLoanTransfer", LazyPanelHomeLoanTransfer],
["PanelInfo", LazyPanelInfo],
["PanelInvoiceReader", LazyPanelInvoiceReader],
["PanelLeadCapture", LazyPanelLeadCapture],
["PanelMultiNavigation", LazyPanelMultiNavigation],
["PanelPersonalLoan", LazyPanelPersonalLoan],
["ReferralForm", LazyReferralForm],
["ProductShowcase", LazyProductShowcase],
["ProductShowcaseItemBb", LazyProductShowcaseItemBb],
["ProductShowcaseItemCc", LazyProductShowcaseItemCc],
["SimulatorDeed", LazySimulatorDeed],
["SimulatorEuribor", LazySimulatorEuribor],
["SimulatorHomeLoan", LazySimulatorHomeLoan],
["SimulatorImi", LazySimulatorImi],
["SimulatorIrs", LazySimulatorIrs],
["SimulatorIrsTable", LazySimulatorIrsTable],
["SimulatorLoan", LazySimulatorLoan],
["SimulatorWage", LazySimulatorWage],
["SimulatorWageTable", LazySimulatorWageTable],
["LegalText", LazyLegalText],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
